import { Component } from '@angular/core';
import { faAngleRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-corporate-onboarding',
  templateUrl: './corporate-onboarding.component.html',
  styleUrls: ['./corporate-onboarding.component.scss',],
})
export class CorporateOnboardingComponent {

  faAngleRight = faAngleRight;
  faArrowRight = faArrowRight;
  onboardingKeys = [
    { icon: 'csignup.svg', label: 'Signup and share your company details', },
    { icon: 'csignlease.svg', label: 'Sign a digital lease agreement', },
    { icon: 'cstartsub.svg', label: 'Your employees can start subscribing', }
    ,
  ];
}
